import { render } from "./DynamicRender.vue?vue&type=template&id=5ffa2c50"
import script from "./DynamicRender.vue?vue&type=script&lang=js"
export * from "./DynamicRender.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__